import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import ScoreIcon from "rs-components/ScoreIcon";
import HtmlText from "components/HtmlText";
import { CutType } from "shared/types";
import { processVariablesSelector } from "store/global/global.selectors";
import { InsightOutputTypes, } from "store/rs-workspace/rs-workspace.types";
import { insightOperationDescriptionsSelector, workspaceRecipesSelector, workspaceSimulationsSelector, } from "store/rs-workspace/selectors/rs-workspace.selectors";
import { checkCanDisplayScore, getAssessmentUsedRecipeIds, getOperationSummaryText, getTimeframeValueWithLabel, prepareBaseScoreItem, } from "store/rs-workspace/utils/insights.utils";
import { getRecipesCustomVariables } from "store/rs-workspace/utils/scenario.utils";
import { isNotEmpty } from "utils/validate";
import { getSelectedProcessVariable } from "store/global/global.utils";
import * as styles from "./styles.module.scss";
const OutputScoreText = ({ output, outputScore, inputSetInputs, index }) => {
    const workspaceSimulations = useSelector(workspaceSimulationsSelector);
    const workspaceRecipes = useSelector(workspaceRecipesSelector);
    const processVariables = useSelector(processVariablesSelector);
    const operationDescriptions = useSelector(insightOperationDescriptionsSelector);
    const { processVariable, operation, timeFrame, transformationOperation, type: outputType, sourceA, sourceB, } = useMemo(() => ({ ...output }), [output]);
    const timeFrameText = useMemo(() => {
        const usedRecipeIds = getAssessmentUsedRecipeIds(workspaceSimulations, workspaceRecipes, inputSetInputs, outputType ?? null, sourceA, sourceB);
        const customVariablesList = getRecipesCustomVariables(workspaceRecipes, usedRecipeIds);
        return getTimeframeValueWithLabel(workspaceRecipes, workspaceSimulations, processVariables, inputSetInputs ?? [], customVariablesList, output)?.label;
    }, [
        workspaceSimulations,
        workspaceRecipes,
        inputSetInputs,
        outputType,
        sourceA,
        sourceB,
        processVariables,
        output,
    ]);
    if (!isNotEmpty(processVariable) ||
        !isNotEmpty(operation) ||
        (timeFrame?.type === CutType.TimeSeries && !isNotEmpty(transformationOperation))) {
        return null;
    }
    return (React.createElement("div", { className: styles["output-description"], key: index },
        React.createElement(ScoreIcon, { className: styles["output-description-value"], highlighted: true, ...prepareBaseScoreItem(outputScore, checkCanDisplayScore(output, inputSetInputs ?? [], processVariables, workspaceRecipes)) }),
        React.createElement(HtmlText, { text: getOperationSummaryText(outputType === InsightOutputTypes.Comparison
                ? operationDescriptions.comparisonDescriptions
                : operationDescriptions.evaluationDescriptions, {
                value: getSelectedProcessVariable(processVariables, processVariable?.type)?.key ?? "",
                label: getSelectedProcessVariable(processVariables, processVariable?.type)?.name ?? "",
            }, {
                ...operation,
                type: { value: operation?.type, label: operation?.type },
            }, {
                ...transformationOperation,
                operationType: {
                    value: transformationOperation?.operationType,
                    label: transformationOperation?.operationType,
                },
            }, timeFrame?.type === CutType.PointInTime, timeFrameText), targetClassName: styles["output-description-text"] })));
};
export default OutputScoreText;
